import { ChangeEvent, useEffect, useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { DictionaryItem } from '../../../../hoc/new-application/types';
import { COFAndIndividualQuestionnarieFormValues } from '../../../../hoc/individual/types';

const useSourceOfIncome = ({
  sourceOfIncome,
  questionnarieFields,
  sourceOfIncomeValues,
  sourceOfIncomeValue,
  questionnarieSetValue,
}: {
  sourceOfIncome?: DictionaryItem[];
  questionnarieFields?: COFAndIndividualQuestionnarieFormValues;
  sourceOfIncomeValues?: {
    id?: string | undefined;
    sourceId: string;
    value: string | number;
  }[];
  sourceOfIncomeValue?: {
    id?: string | undefined;
    sourceId: string;
    value: string | number;
  };
  questionnarieSetValue?: UseFormSetValue<COFAndIndividualQuestionnarieFormValues>;
}) => {
  const [sourceOfIncomeFiltered, setSourceOfIncomeFiltered] =
    useState<DictionaryItem[]>();
  const [totalValue, setTotalValue] = useState(0);

  const [formValues, setFormValues] = useState<{
    id?: string;
    sourceId: string;
    value: number | string;
  }>();
  const [listVisible, setListVisible] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextFormValues = { ...formValues };

    const nextSourceOfIncomeValues = sourceOfIncomeValues?.map((item) => {
      const result = { ...item };

      if (result.id === sourceOfIncomeValue?.id) {
        if (e.target.name === `sourceId-${result?.id}`) {
          result.sourceId = e.target.value;
          nextFormValues.sourceId = e.target.value;
        } else if (e.target.name === `value-${result?.id}`) {
          result.value = e.target.value;
          nextFormValues.value = e.target.value;
        }
      }

      return result;
    });

    setFormValues(
      nextFormValues as {
        id?: string;
        sourceId: string;
        value: number | string;
      },
    );

    if (questionnarieSetValue) {
      questionnarieSetValue(
        'sourcesOfIncomes',
        nextSourceOfIncomeValues as {
          sourceId: string;
          value: number | string;
        }[],
      );
    }
  };

  const onDelete = () => {
    if (questionnarieSetValue) {
      questionnarieSetValue(
        'sourcesOfIncomes',
        sourceOfIncomeValues?.filter(
          (item) =>
            item?.sourceId !== sourceOfIncomeValue?.sourceId &&
            item?.id !== sourceOfIncomeValue?.id,
        ),
      );
    }
  };

  useEffect(() => {
    if (sourceOfIncomeValue) {
      setFormValues(sourceOfIncomeValue);
    }
  }, [sourceOfIncomeValue]);

  useEffect(() => {
    if (sourceOfIncome && questionnarieFields?.sourcesOfIncomes) {
      setSourceOfIncomeFiltered(
        sourceOfIncome?.filter((item) =>
          questionnarieFields?.sourcesOfIncomes?.every(
            (income) => item.id !== income.sourceId,
          ),
        ),
      );
    }
  }, [questionnarieFields?.sourcesOfIncomes, sourceOfIncome]);

  useEffect(() => {
    if (
      questionnarieFields?.sourcesOfIncomes?.filter((item) => item.sourceId)
        ?.length
    ) {
      let totalSourceOfIncome = 0;

      questionnarieFields?.sourcesOfIncomes
        ?.filter((item) => item.sourceId)
        ?.forEach((item) => {
          totalSourceOfIncome += Number(item.value);
        });

      setTotalValue(totalSourceOfIncome);
    }
  }, [questionnarieFields?.sourcesOfIncomes]);

  return {
    sourceOfIncomeFiltered,
    totalValue,
    setListVisible,
    listVisible,
    formValues,
    onChange,
    onDelete,
  };
};

export default useSourceOfIncome;
